import React, { useState } from 'react';
import TAlogo from './TAlogo.jpg';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isRealEstatePage = location.pathname === '/realestate-demo';

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setMenuOpen(false);

    const section = document.getElementById(targetId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      // fallback: navigate to home with hash (in case not on homepage)
      window.location.href = `/#${targetId}`;
    }
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navLogo}>
        <Link to="/" onClick={() => {
  window.scrollTo(0, 0);
  setMenuOpen(false);
}}>
          <img src={TAlogo} alt="Tailored Approach Logo" className={styles.navImg} />
        </Link>
        <span>Tailored Approach</span>
      </div>

      <button className={styles.hamburger} onClick={toggleMenu}>
        ☰
      </button>

      <ul className={`${styles.navLinks} ${menuOpen ? styles.mobileOpen : ''}`}>
        <li>
          <a
            href={isRealEstatePage ? "/#services" : "#services"}
            onClick={(e) => handleNavClick(e, 'services')}
          >
            Services
          </a>
        </li>
        <li>
          <a
            href="#book"
            onClick={(e) => handleNavClick(e, 'book')}
          >
            Book a Call
          </a>
        </li>
        {!isRealEstatePage && (
          <li>
            <Link to="/realestate-demo" onClick={() => setMenuOpen(false)}>
              Real Estate
            </Link>
          </li>
        )}
        {isRealEstatePage && (
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
